@if (loading()) {
  <div class="flex flex-col gap-3">
    <div class="flex w-full gap-[2px]">
      @for (slot of skeletonSlots(); track slot) {
        <div class="flex flex-1 justify-center">
          <ngx-skeleton-loader class="h-5" [theme]="{ width: '40px', height: '20px', 'border-radius': '4px' }" />
        </div>
      }
    </div>

    <div class="flex h-10 w-full gap-[2px] overflow-hidden rounded-lg">
      @for (slot of skeletonSlots(); track slot) {
        <div class="h-full flex-1">
          <ngx-skeleton-loader
            class="!block h-full w-full"
            [theme]="{ width: '100%', height: '100%', 'border-radius': '0' }"
          />
        </div>
      }
    </div>

    <div class="flex flex-wrap items-center gap-x-6 gap-y-2">
      @for (slot of skeletonSlots(); track slot) {
        <div class="flex items-center gap-2">
          <ngx-skeleton-loader
            class="h-2 flex"
            [theme]="{ width: '8px', height: '8px', 'border-radius': '50%', margin: '0' }"
          />
          <ngx-skeleton-loader
            class="h-5 flex"
            [theme]="{ width: '80px', height: '20px', 'border-radius': '4px', margin: '0' }"
          />
        </div>
      }
    </div>
  </div>
} @else {
  <div class="flex flex-col gap-3">
    <div class="flex w-full gap-[2px]">
      @for (segment of segments(); track segment.id) {
        <div
          class="flex justify-center text-sm font-semibold text-shikenso-purple-base"
          [style.flex]="segmentFlex(segment)"
        >
          {{ segment.value | number }}
        </div>
      }
    </div>

    <div class="flex h-10 w-full gap-[2px] overflow-hidden rounded-lg">
      @for (segment of segments(); track segment.id) {
        <div
          class="h-full"
          [ngClass]="segment.colorClass"
          [style.flex]="segmentFlex(segment)"
          [matTooltip]="segment.label"
          matTooltipPosition="above"
        ></div>
      }
    </div>

    <div class="flex flex-wrap items-center gap-x-6 gap-y-2">
      @for (segment of segments(); track segment.id) {
        <div class="flex items-center gap-2 text-sm text-shikenso-purple-base-60">
          <span class="h-2 w-2 shrink-0 rounded-full" [ngClass]="segment.colorClass"></span>
          {{ segment.label }}
        </div>
      }
    </div>
  </div>
}
